/* eslint-disable react/prop-types */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, RefObject, useRef } from 'react'
import { Tabs } from 'antd-mobile'
import { observer } from 'mobx-react'
import { Models } from 'rmc-tabs/lib/Models'
import TextArea from 'antd/lib/input/TextArea'
import { TabTxt, WhiteChildTabWrap } from '@styles/base.style'
import { Button } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
import { CHAT_TAB_INDEX_KEY } from '@constants/index'
import { isMobile } from 'react-device-detect'
import { AllChatIco, BetListIco } from '@shared/Icon/Chat'
import Login from '@views/Login'
import { ChatItem } from '../ChatItem'
import { ChatLoginBtn } from '../index.style'

interface ChatTabProps {
  chatInputRef: RefObject<TextArea>
  chatInputAreaRef: RefObject<HTMLDivElement>
  showKeyboard: boolean
  hideEmoticonPanelHandler: () => void
}

const ChatTab: React.FC<ChatTabProps> = (props: ChatTabProps) => {
  const { chattingStore, authStore } = useRootStore()
  const { chatInputRef, chatInputAreaRef, showKeyboard, hideEmoticonPanelHandler } = props
  const { currentTabIndexKey, isVisibleChattingModal } = chattingStore
  const chatListContentParentRefs = useRef<{ [key: string]: HTMLUListElement }>({})

  const tabs = [
    {
      title: <TabTxt className="white-tab-txt column"><AllChatIco/>채팅</TabTxt>,
      key: CHAT_TAB_INDEX_KEY.ALL,
    },
    // {
    //   title: <TabTxt className="white-tab-txt"><ReplyIco /></TabTxt>,
    //   key: CHAT_TAB_INDEX_KEY.RECEIVED_MESSAGE,
    // },
    {
      title: <TabTxt className="white-tab-txt column"><BetListIco/>공유내역</TabTxt>,
      key: CHAT_TAB_INDEX_KEY.SHARED_BET_HISTORY,
    },
  ]
  const onChangeTabHandler = (tab: Models.TabData, index: number) => {
    chattingStore.changeChattingTabState(tab.key as CHAT_TAB_INDEX_KEY)
    chattingStore.setDelayChatAreaScrollToBottom()
  }

  const renderContent = (tab) => {
    const tabKey = tab.key
    const chatListId = `chatList_${tabKey}`
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
      <ul id={chatListId} className="chat-list"
          style={{ top: 0 }}
          ref={el => {
            chatListContentParentRefs.current[tabKey] = el
          }}
          onClick={() => {
            chatInputRef.current.blur()
            hideEmoticonPanelHandler()
          }}>
        <ChatItem
          key={`${chatListId}_chatItem`}
          showKeyboard={showKeyboard}
          chatInputAreaRef={chatInputAreaRef}
          chatInputRef={chatInputRef}
          parentRefs={chatListContentParentRefs}/>
      </ul>
    )
  }

  let childTabWrapClassName = 'chat-tab-wrap'
  if (!isVisibleChattingModal && isMobile) {
    childTabWrapClassName += ' close'
  } else if (!isMobile) {
    childTabWrapClassName += ' pc-chat-tab'
  }

  const onClickLoginHandler = () => {
    authStore.showLoginPopup(<Login/>)
  }

  return (
    <Fragment>
      <WhiteChildTabWrap className={childTabWrapClassName}>
        <Tabs tabs={tabs}
              initialPage={currentTabIndexKey}
              page={currentTabIndexKey}
              swipeable={false}
          // animated={false}
              onChange={onChangeTabHandler}
              renderTabBar={tabsProps => <Tabs.DefaultTabBar {...tabsProps} page={tabs.length}/>}
        >
          {renderContent}
        </Tabs>
        {!authStore.isSignedIn && <Button TP css={ChatLoginBtn} className="tab-btn" onClick={onClickLoginHandler}/>}
      </WhiteChildTabWrap>
    </Fragment>
  )
}

export default observer(ChatTab)
